module.exports = __webpack_public_path__ + "static/img/Huella de producto.258e4f0a.png";